import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { PageWrapper } from "components/ui/PageWrapper";
import { Edit2, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ButtonLoader } from "components/Loader/ButtonLoader";
import { Button } from "components/ui/Button";
import { tableCustomStyles } from "app/mock/catalog";
import { GetTeamMemberMutation, DeleteTeamMemberMutation, GetTeamSectionConfig, UpdateTeamSectionConfig } from "rest/personnel";
import { ComponentLoader } from "components/Loader/ComponentLoader";
import { ErrorComponent } from "components/Alerts/Error";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { FormInput } from "components/ui/FormInput";
import { useForm } from "react-hook-form";

export default function OurTeam() {
  const [id, setId] = useState("");
  const navigate = useNavigate();

  const getAllTeamMember = GetTeamMemberMutation();
  const deleteTeamMember = DeleteTeamMemberMutation();
  const teamSectionConfig = GetTeamSectionConfig();
  const updateTeamSectionConfig = UpdateTeamSectionConfig();

  const { register, handleSubmit, reset } = useForm();

  useEffect(() => {
    if (teamSectionConfig?.data?.data) {
      reset({
        link_label: teamSectionConfig.data.data.link_label,
        link_url:   teamSectionConfig.data.data.link_url,
      });
    }
  }, [teamSectionConfig?.data?.data]);

  const onConfigSubmit = (data) => {
    const formData = new FormData();
    formData.append("link_label", data.link_label || "");
    formData.append("link_url",   data.link_url   || "");
    updateTeamSectionConfig.mutate(formData);
  };

  const handleDelete = (id) => {
    const formData = new FormData();
    formData.append("teamId", id);
    deleteTeamMember.mutate(formData);
  };

  const teamMembersColumns = [
    {
      name: "Sort No",
      selector: (row) => row?.sortNo,
    },
    {
      name: "name",
      selector: (row) => row.name,
    },
    {
      name: "designation",
      selector: (row) => row.designation,
    },
    {
      name: "edit",
      cell: (row) => (
        <span
          className="editbtn"
          onClick={() => navigate(`/edit-team-members/${row?.id}`)}
        >
          <Edit2 row={row} />
        </span>
      ),
      button: true.toString(),
      style: {},
    },
    {
      name: "Delete",
      cell: (row) =>
        row?.id === id && deleteTeamMember?.isPending ? (
          <ButtonLoader />
        ) : (
          <span
            onClick={() => {
              handleDelete(row?.id);
              setId(row?.id);
            }}
            className="deletebtn"
          >
            <Trash2 row={row} />
          </span>
        ),
      button: "true",
    },
  ];
  return (
    <div className="personnel_page">
      <PageWrapper slug="our-team" name="Our Team" />

      <div className="home_banner_input mb-5">
        <h5 className="mb-3">Team Section — Bottom Link</h5>
        <form onSubmit={handleSubmit(onConfigSubmit)} className="row mt-2">
          <div className="mb-3 col-md-6">
            <label className="form-label">Link Button Text</label>
            <FormInput
              type="text"
              placeholder="e.g. Join Our Team"
              {...register("link_label")}
            />
          </div>
          <div className="mb-3 col-md-6">
            <label className="form-label">Link URL</label>
            <FormInput
              type="text"
              placeholder="e.g. /employment"
              {...register("link_url")}
            />
          </div>
          <div className="col-12">
            {updateTeamSectionConfig.isPending ? (
              <ButtonLoader />
            ) : (
              <input type="submit" value="Save" className="input_submit" />
            )}
          </div>
        </form>
      </div>

      <div className="d-flex justify-content-end mb-4 add_catalog_btn ">
        <Button onClick={() => navigate("/add-team-members")}>
          Add Members
        </Button>
      </div>
      {getAllTeamMember?.isError && (
        <ErrorComponent message="OOPS ! something went wrong please try again later" />
      )}
      {getAllTeamMember?.isPending ? (
        <ComponentLoader />
      ) : (
        <DataTableExtensions
          columns={teamMembersColumns}
          data={getAllTeamMember?.data?.data?.sort((a, b) => b?.id - a?.id)}
          filterPlaceholder="Search"
        >
          <DataTable
            pagination
            paginationPerPage={10}
            striped
            customStyles={tableCustomStyles}
          />
        </DataTableExtensions>
      )}
    </div>
  );
}
